require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ./bower_components/angular-sanitize/index.js
// module id = 730
// module chunks = 0